import React from 'react';

/**
 * Map marker for an Explore Unknown minigame (authoring-space SVG coordinates).
 * @param {{ x: number, y: number, interactive?: boolean, onClick?: () => void, waypointEditMode?: boolean }} props
 */
export default function ExploreUnknownMinigameMapMarker({
  x,
  y,
  interactive = false,
  onClick,
  waypointEditMode = false,
}) {
  if (typeof x !== 'number' || typeof y !== 'number' || !Number.isFinite(x) || !Number.isFinite(y)) {
    throw new Error('ExploreUnknownMinigameMapMarker: x and y must be finite numbers');
  }

  const canActivate = interactive && !waypointEditMode && typeof onClick === 'function';

  return (
    <g
      className="explore-unknown-minigame-poi"
      style={{
        pointerEvents: waypointEditMode || !canActivate ? 'none' : 'auto',
        cursor: canActivate ? 'pointer' : 'default',
      }}
      role={canActivate ? 'button' : undefined}
      tabIndex={canActivate ? 0 : undefined}
      onClick={
        canActivate
          ? (e) => {
              onClick();
              e.currentTarget.blur();
            }
          : undefined
      }
      onKeyDown={
        canActivate
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick();
              }
            }
          : undefined
      }
    >
      <circle cx={x} cy={y} r="32" fill="transparent" />
      <circle
        cx={x}
        cy={y}
        r="14"
        fill={canActivate ? 'rgba(20, 50, 40, 0.92)' : 'rgba(28, 36, 32, 0.88)'}
        stroke={canActivate ? 'rgba(134, 239, 172, 0.95)' : 'rgba(80, 120, 100, 0.7)'}
        strokeWidth="3"
      />
      <text
        x={x}
        y={y + 5}
        textAnchor="middle"
        fill="rgba(220, 252, 231, 0.95)"
        fontSize="14"
        fontWeight="700"
        style={{ pointerEvents: 'none', userSelect: 'none' }}
      >
        ✦
      </text>
    </g>
  );
}
